import React, { Component } from 'react';
import {RoundedRectButton} from 'components/UI/Form';
import BusinessContentDetailItem from './BusinessContentDetailItem.jsx';
import './_business-content-container.scss';

class BusinessContentContainer extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      contents: this.props.initialData || []
    }
  }

  addBusinessContent() {
    this.setState({
      contents: [
        ...this.state.contents,
        {
          title: '',
          content: ''
        }
      ]
    });
  }

  removeItem(item) {
    let contents = this.state.contents.filter(content => {
      return content != item;
    });

    this.setState({contents});

    this.props.onChange(contents);
  }

  onBusinessContentChange(original, newContent) {
    let newContents = this.state.contents.map(content => {
      if (content === original) {
        return newContent;
      } else {
        return content;
      }
    });

    this.setState({
      contents: newContents
    });

    this.props.onChange(newContents);
  }

  render() {
    return (
      <section className="business-content-container">
        <div className='wrap-business-des'>
          <h3 className='wrap-business-des-title txt-upper'>Giới thiệu thêm về doanh nghiệp</h3>
          <div className='wrap-business-des-item'>
            {
              (!this.state.contents || this.state.contents.length == 0) &&
              <div className="no-content">Chưa có thông tin bổ sung nào</div>
            }
            {
              this.state.contents.map((item, i) => {
                return(
                  <BusinessContentDetailItem key={i} countNumber={i + 1} {...item}
                    onItemRemove={this.removeItem.bind(this, item)}
                    onChange={this.onBusinessContentChange.bind(this, item)}
                  />
                )
              })
            }
          </div>
          <div className='btn-add-more-detail-item-wrap'>
            <RoundedRectButton type="button" onClick={this.addBusinessContent.bind(this)}>Thêm thông tin</RoundedRectButton>
          </div>
        </div>
      </section>
    );
  }

}

export default BusinessContentContainer;



// WEBPACK FOOTER //
// ./components/my-business/profile/BusinessContentContainer.jsx